/// <amd-module name="Test/ManualTestReports/TestReportsCommon/TelemetryService" />
import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { getTFSPageData, ITfsPageData } from "Tfs/Platform/Page";
import * as TelemetryConstants from "Test/ManualTestReports/TestReportsCommon/TelemetryConstants";
import { IFilterState } from "VSSUI/Utilities/Filter";
import { ITestProgressReportFilterState } from "Test/ManualTestReports/TestReportsCommon/Contracts";
import { FilterHelper } from "Test/ManualTestReports/TestReportsCommon/FilterHelper";
import { isAdvancedTestExtensionEnabled } from "Test/ManageTestPlans/LicenseUtils";

export function publishEvent(
    pageContext: IVssPageContext,
    feature: string,
    properties: { [key: string]: any },
    filterState?: IFilterState) {
    try {
        const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");

        properties = {...getDefaultTelemetryProperties(pageContext), ..._getFilterTelemetryProperties(filterState), ...properties}

        telemetryService.publishEvent(TelemetryConstants.Area, feature, properties);
    } catch (e) {
        console.error(Utils_String.format("[TelemetryService.publishEvent]: Error in logging Customer Intelligence data. Error: {0}", e.message));
    }
}

export function getDefaultTelemetryProperties(pageContext: IVssPageContext): any {
    const tfsProjectData: ITfsPageData | undefined = getTFSPageData(pageContext);
    if(tfsProjectData && tfsProjectData.project){
        const project = tfsProjectData.project;
        return {
            projectName: project.name,
            projectId: project.id,
            projectUrl: project.url,
            referrer: document.referrer,
            isAdvancedLicenseEnabled: isAdvancedTestExtensionEnabled(pageContext)
        }
    }
    else {
        return {};
    }
}

function _getFilterTelemetryProperties(filterState?: IFilterState): any  {
    if (filterState) {
        let progressReportFilterState: ITestProgressReportFilterState = FilterHelper.getTestProgressFilterState(filterState);
        return {
            numberOfSelectedTestPlans : progressReportFilterState.selectedPlanIds.length,
            numberOfSelectedPriorities: progressReportFilterState.selectedPriorityValues.length,
            numberOfSelectedConfiguration: progressReportFilterState.selectedConfigurations.length,
            numberOfSelectedAssignedTo: progressReportFilterState.selectedAssignedToValues.length,
            numberOfSelectedTester: progressReportFilterState.selectedTesterValues.length
        }
    } else {
        return {};
    }
}
